module.exports = __webpack_public_path__ + "img/1534374860.f936ff5e.jpg";